import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import { Attachment, AttachmentParentTypes, FormDefinitions } from "../../api/dtos";

export interface IAttachmentFormByIdRouteProps extends PropsWithChildren {
    attachmentId?: number | undefined;
    attachmentParentType?: AttachmentParentTypes;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const AttachmentFormByIdRoute: FC<IAttachmentFormByIdRouteProps> = ({
    attachmentId,
    attachmentParentType,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const projectId = Number(params.projectId);
    const stageId = Number(params.stageId);
    const lotId = Number(params.lotId);

    const attachmentIdToUse = (params.attachmentId ? +params.attachmentId : undefined) ?? attachmentId ?? undefined;
    const attachmentParentTypeToUse = attachmentParentType ?? (params.lotId ? AttachmentParentTypes.Lot : AttachmentParentTypes.Stage);

    return (
        <ContextFormByIdProvider
            formId={attachmentIdToUse}
            createData={
                attachmentParentTypeToUse === AttachmentParentTypes.Lot ?
                new Attachment({
                    attachmentParentType: AttachmentParentTypes.Lot,
                    attachmentParentId: lotId
                }) :
                attachmentParentTypeToUse === AttachmentParentTypes.Stage ?
                new Attachment({
                    attachmentParentType: AttachmentParentTypes.Stage,
                    attachmentParentId: stageId

                }) :
                new Attachment({
                    attachmentParentType: AttachmentParentTypes.Project,
                    attachmentParentId: projectId
                })
            }
            formDefinitionIdentifier={FormDefinitions.Attachment}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default AttachmentFormByIdRoute;
